import { render } from "./CompareRack.vue?vue&type=template&id=018c143e"
import script from "./CompareRack.vue?vue&type=script&lang=js"
export * from "./CompareRack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__